import Link from 'next/link'
import classnames from 'classnames'
import { CSSProperties, FC } from 'react'

import { GlowHeading, Typography, Grid, Flex, TextCol, Link as GLink } from '~ui'
import Markdown from '~shared/Markdown'
import Card from './card'
import { BannerProps, CardProps } from './banner.type'

import styles from './Banner.module.scss'

const { Paragraph } = Typography

const FullSizeBanner: FC<CardProps> = ({ description, imageUrl, link, title, fields }) => (
  <div className={classnames(styles.wrapper, styles['wrapper-full-size'])}>
    <div className={styles.description}>
      <Link legacyBehavior href={link}>
        <a className={styles.link}>
          <h3>{title}</h3>
        </a>
      </Link>
      {fields && (
        <Flex flexDirection="column" paddingBottom="1rem">
          {fields.map((field) => (
            <TextCol key={field[0].text} fields={field} />
          ))}
        </Flex>
      )}
      <Paragraph color="g-gray-1">
        <Markdown md={description} />
      </Paragraph>
      <GLink color="green" href={link}>
        Learn more
      </GLink>
    </div>
    <div className={styles.image} style={{ '--image-url': `url(${imageUrl})` } as CSSProperties} />
  </div>
)

const MultipleBanner: FC<{ items: CardProps[] }> = ({ items }) => (
  <div className={classnames(styles.wrapper, styles['wrapper-multiple'])}>
    {items.map(({ ...props }) => (
      <Card key={props.title} {...props} flexible />
    ))}
  </div>
)

const Banner: FC<BannerProps> = ({ items, title }) => (
  <Grid gap="2rem" width="100%">
    <GlowHeading Tag="h2" glow={false} fill>
      {title}
    </GlowHeading>
    {items.length === 1 ? (
      items.map((data) => <FullSizeBanner key={title} {...data} />)
    ) : (
      <MultipleBanner items={items} />
    )}
  </Grid>
)

export default Banner
